import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const couponSlice = createApi({
    reducerPath: "couponSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCoupons: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/backend/v1/coupon?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Location
        addCoupon: builder.mutation({

            query: (body) => ({
                url: "/offer",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateCoupon: builder.mutation({
            query: ({ id, body }) => ({
                url: `/offer/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteCoupon: builder.mutation({
            query: (id) => ({
                url: `/backend/v1/coupon/${id}`,
                method: "DELETE",
            }),
        }),

        // getTypeSubCat: builder.query({
        //     query: ({ selectedCategory = "" }) => ({
        //         url: `/category?type=${selectedCategory}`,
        //         method: "GET",
        //     }),
        //     transformResponse: (response) => response,
        // }),

    }),
});

export const {
    useGetCouponsQuery,
    useAddOffersMutation,
    useUpdateOfferMutation,
    useDeleteCouponMutation,
} = couponSlice;
